// retry-policy-evidence.ts
//
// Tách khỏi retry-policy.ts (giữ mỗi file ≤200 dòng): phần "kể lại chuyện đã
// xảy ra" — redact evidence trước khi lưu. (Dựng ticket con khi tách đã bỏ —
// SOL-06: điểm tách giờ chuyển cho người, xem retry-policy.ts.)
// Phần quyết định retry/blocked/escalate ở lại retry-policy.ts.
//
// ⛔ Cùng luật §18 như file mẹ: không literal ngưỡng, mọi số là tham số.
import { SecretRedactor } from "./secret-redactor.js";

/**
 * Redact evidence trước khi nó vào decision → journal → Mattermost. Đường
 * `feed()` + `flush()` là bắt buộc: `feed` giữ lại một đoạn đuôi phòng khi
 * secret bị cắt ngang chunk, chỉ `flush` mới nhả nốt phần đó.
 */
export function redactEvidence(evidence: string, secretValues: string[]): string {
  const redactor = new SecretRedactor({ secretValues });
  return `${redactor.feed(evidence)}${redactor.flush()}`;
}
